import { UPDATE_BACKGROUND_PROCESSING } from "../helpers/actions";
import { withProperties, isPlainObject, isBoolean } from "../../utils";

export default function state() {
  const NAME = 'backgroundProcessing';
  const $state = Object.create(null);

  function Reducer(state = false, action) {
    const payload = isPlainObject(action.payload) ? action.payload : {};

    switch (action.type) {
      case UPDATE_BACKGROUND_PROCESSING: {
        const { processing } = payload;
        return isBoolean(processing) && processing !== state ? processing : state;
      }

      default: return state;
    }
  }

  function updateBackgroundProcessing(processing) {
    return (dispatch) => {
      dispatch({ type: UPDATE_BACKGROUND_PROCESSING, payload: { processing }});
    }
  }

  // Augment $state with properties
  withProperties($state, {
    NAME,
    Reducer,
    actions: withProperties(Object.create(null), { updateBackgroundProcessing })
  });

  return (state = $state);
}
